export enum Colors {
  Primary = 'primary',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  TextSecondary = 'textSecondary',
}
